import { MY_ACCOUNT_SHOPPING_LISTS_URL } from 'features/my-account/routes.commerce';
import React, { useEffect, useState } from 'react';
import { Localizer } from 'services/Localizer';
import { AddToListResponse } from 'services/UserData.Commerce';

interface AddedToListAlertProps {
	response: AddToListResponse;
	setPopupOpen: (value: boolean) => void;
}

/**
 * Displays Added to List confirmation
 */
export default function AddedToListAlert(props: AddedToListAlertProps) {
	const { response } = props;
	const [displayAlert, setDisplayAlert] = useState(true);

	useEffect(() => {
		setDisplayAlert(true);
	}, [response]);

	if (!displayAlert) {
		return null;
	}

	return (
		<div className="roc-item-summary">
			<div className="roc-item-summary__section">
				<div className="roc-item-summary__item">
					<div className="roc-item-summary__image-wrapper">
						{response.imageUrl ? (
							<img className="roc-item-summary__image" alt={response.name} src={response.imageUrl} />
						) : (
							<img
								className="roc-item-summary__image"
								alt={response.name}
								src="/images/image-not-found-medium.png"
							/>
						)}
					</div>
					<div className="roc-item-summary__text">
						<p>
							<strong>{response.name}</strong>
						</p>
						<p>
							{/* #region HCL - replace SKU to ItemNumber */}
							{Localizer('ItemNumber')}: &nbsp;
							{/* #endregion */}
							<span data-testid="added-to-cart-sku">{response.sku}</span>
						</p>

						<table className="roc-item-summary__attributes">
							<tbody>
								{response.selections !== null && response.selections.length > 0
									? response.selections.map((selection) => (
											<tr
												className="roc-item-summary__row"
												key={`added-to-cart-alert-selection-${selection.name}`}
											>
												<td className="roc-item-summary__col roc-item-summary__col--property">
													<strong>{selection.name}:</strong>
												</td>

												<td className="roc-item-summary__col roc-item-summary__col--value">
													{selection.label}
												</td>
											</tr>
									  ))
									: null}

								<tr className="roc-item-summary__row">
									<td className="roc-item-summary__col roc-item-summary__col--property">
										<strong>{Localizer('Qty')} </strong>
									</td>

									<td className="roc-item-summary__col roc-item-summary__col--value">
										{response.quantity}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div className="roc-item-summary__section">
				<div className="roc-item-summary__btn-row">
					<div className="roc-item-summary__btn-col">
						<button
							type="button"
							onClick={() => props.setPopupOpen(false)}
							className="roc-btn-secondary roc-btn-secondary--big roc-btn-secondary--block roc-item-summary__btn"
							data-testid="continue-shopping-btn"
						>
							{Localizer('ContinueShopping')}
						</button>
					</div>
					<div className="roc-item-summary__btn-col">
						<button
							type="button"
							onClick={() =>
								(window.location.href = `${MY_ACCOUNT_SHOPPING_LISTS_URL}/${response.shoppingListId}`)
							}
							className="roc-btn roc-btn--big roc-btn--block roc-item-summary__btn"
							data-testid="view-list-btn"
						>
							<span className="roc-item-summary__btn-text">{Localizer('ViewList')}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
